import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade , Thumbs } from 'swiper/modules';
import 'swiper/css/bundle';
import AOS from 'aos';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs]);
window.Swiper = Swiper;

// JavaScript
$(document).ready( function () {
  //scroll top
  // $('.back-to-top').click(function(event){
  //   $("html,body").animate({scrollTop: 0}, 1000);
  // });

  // transparent header
  function headerScroll() {
    if ($(window).scrollTop() > 100) {
      $('.header').addClass("min-header");
    } else {
      $('.header').removeClass("min-header");
    }
  }
  headerScroll();
  $(window).on('scroll', function () {
    headerScroll();
  });

  $('.header-mobile-menu').on('click', function () {
    $(this).parents('.header-container').toggleClass('menu-active');
  });

  $('.menu-link').click(function(e) {
    $(this).parent().toggleClass('active').siblings().removeClass('active');
  });

  var indexBanner = new Swiper('#indexBanner', {
    effect: 'fade',
    fadeEffect: { crossFade: true },
    autoplay: { delay: 1000 },
    loop: true,
    speed: 6000, // 要和 keyframes 的時間一致
    pagination: { el: '.swiper-pagination', clickable: true },
    on: {
      slideChangeTransitionStart: function () {
        // 移除舊動畫
        this.slides.forEach((slide) => {
          const img = slide.querySelector('img');
          if (img) img.classList.remove('zoom-out-fade');
        });

        // 給上一張圖加上放大淡出的動畫
        const prevSlide = this.slides[this.previousIndex];
        if (prevSlide) {
          const prevImg = prevSlide.querySelector('img');
          if (prevImg) {
            prevImg.classList.add('zoom-out-fade');
          }
        }
      }
    }
  });

  var indexRenewal = new Swiper('#indexRrenewal', {
    slidesPerView: 3,
    navigation: {
      prevEl: ".index-renewal-prev",
      nextEl: ".index-renewal-next",
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      800: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 25,
      },
    },
  });

  var showcaseImgsThumb = new Swiper("#showcase_imgs_thumb", {
    spaceBetween: 5,
    slidesPerView: 7,
    freeMode: true,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    breakpoints: {
      0: {
        spaceBetween: 3,
        slidesPerView: 6,
      },
      640: {
        spaceBetween: 5,
      },
    }
  });

  var showcaseImgs = new Swiper('#showcase_imgs', {
    spaceBetween: 10,
    navigation: {
      prevEl: ".index-showcase-prev",
      nextEl: ".index-showcase-next",
    },
    thumbs: {
      swiper: showcaseImgsThumb,
    },
  });

   var milestone = new Swiper('#milestone', {
    slidesPerView: 3,
    spaceBetween: 0,
    navigation: {
      prevEl: ".index-milestone-prev",
      nextEl: ".index-milestone-next",
    },
    breakpoints: {
      0: {
        slidesPerView: 1.5,
      },
      640: {
        slidesPerView: 2.5,
      },
      800: {
        slidesPerView: 3.7,
      },
      1200: {
        slidesPerView: 4.7,
      },
      1500: {
        slidesPerView: 5.5,
      },
    },
  });

  // dropdown
  $('.dropdown-btn').on('click', function () {
    const id = $(this).attr('id');
    const dropdown_is_active = $('[aria-labelledby=' + id + ']').hasClass("is-active");
    if (dropdown_is_active >= 1) {
      $('[aria-labelledby=' + id + ']').removeClass('is-active');
      if (window.innerWidth <= 640) {
        $('body').css({
          'height': '',
          'overflow': '',
        })
      }
    } else {
      $(".dropdown-list:not([aria-labelledby=" + id + "]").removeClass('is-active');
      $('[aria-labelledby=' + id + ']').addClass('is-active');
      if (window.innerWidth <= 640) {
        $('body').css({
          'height': '100vh',
          'overflow': 'hidden',
        })
      }
    }
  });

  $(document).click(function (event) {
    if (!$(event.target).closest('.dropdown-btn').length) {
      if ($('.dropdown-list').is(":visible")) {
        $(".dropdown-list").removeClass('is-active');
        if (window.innerWidth <= 640) {
          $('body').css({
            'height': '',
            'overflow': '',
          })
        }
      }
    }
  });

  //form input
  document.querySelectorAll('input, select, textarea').forEach(input => {
    input.addEventListener('input', () => {
      if (input.value.length >= 0) {
        input.classList.add('focused')
        input.labels.forEach(label => {
          label.classList.add('focused')
        })
      };
    });

    input.addEventListener('focus', () => {
      input.classList.add('focused')
      input.labels.forEach(label => {
        label.classList.add('focused')
      })
    });

    input.addEventListener('blur', () => {
      if (input.value.length <= 0) {
        input.classList.remove('focused')
        input.labels.forEach(label => {
          label.classList.remove('focused')
        })
      };
    });
  });

  // 上傳圖檔
  const fileInputs = document.querySelectorAll(".form-file-input");
  fileInputs.forEach(function (fileInput) {
    const fileNameSpan = fileInput.closest(".form-file-custom").querySelector(".file-name");

    // 預設顯示 placeholder
    fileNameSpan.classList.add("placeholder");
    fileNameSpan.textContent = "上傳檔案請小於 2MB";

    fileInput.addEventListener("change", function () {
      if (fileInput.files.length > 0) {
        const file = fileInput.files[0];

        // 檔案類型檢查
        if (!file.type.startsWith("image/")) {
          alert("只能上傳圖片檔案 (jpg, png, gif...)");
          fileInput.value = ""; // 清空
          fileNameSpan.classList.add("placeholder");
          fileNameSpan.textContent = "上傳檔案請小於 2MB";
          return;
        }

        // 檔案大小檢查
        if (file.size > 2 * 1024 * 1024) {
          alert("檔案大小需小於 2MB");
          fileInput.value = ""; // 清空
          fileNameSpan.classList.add("placeholder");
          fileNameSpan.textContent = "上傳檔案請小於 2MB";
          return;
        }

        // 通過檢查 → 顯示檔名
        fileNameSpan.classList.remove("placeholder");
        fileNameSpan.textContent = file.name;
      } else {
        fileNameSpan.classList.add("placeholder");
        fileNameSpan.textContent = "上傳檔案請小於 2MB";
      }
    });
  });

  AOS.init({
    once: true,
  });
});

